import React, { useState } from "react";
import { Box, Button, Container, Tab, Tabs } from "@mui/material";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import AddressInfo from "../adminDashboard/PersonalInfo";
import UserProfileInfo from "../adminDashboard/UserProfile";
import QuoatationTab from "../dashboard/QuotationHistory";
import ChangePassword from "../adminDashboard/ChangePassword";
import PriceList from "../adminDashboard/PriceList";
import LogoutAccount from "../adminDashboard/Logout";
import "../../../src/globalCss.css"; // Ensure this path is correct
import changePasswordIcon from "../../assets/images/change-password-icon.svg";
import logoutIcon from "../../assets/images/logout.svg";
import logoVector from "../../assets/images/vector-logo.svg";
import user_account_profile_icon from "../../assets/images/user_account_profile_icon.svg";
import settings from "../../assets/images/settings.png";
import quotation from "../../assets/images/quotation.svg";
import UserList from "./UserList";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AdminSettings from "./AdminSettings";
import AdminUserList from "./AdminList";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
// TabPanel Component
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

// Accessibility Props Function
function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

// VerticalTabs Component
export function VerticalTabs() {
  const [userId, setUserId] = useState(null);
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [expanded, setExpanded] = React.useState(false);

  const handleChange1 = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const sidebarTabCol = {
    sidebar: {
      width: "22%",
      backgroundColor: "#EBEBEB",
      textAlign: "left",
      padding: "35px 25px",
    },
    tab_button: {
      justifyContent: "left",
      alignItems: "flex-start",
      marginBottom: "15px",
      display: "flex",
      fontSize: "17px",
      textTransform: "capitalize",
      fontWeight: "500",
      padding: "14px 22px",
      color: "#333",
    },
    active_tab: {
      backgroundColor: "#FFF", // Active tab background color
      color: "#333", // Active tab text color
      borderRadius: "50px",
      fontWeight: "500",
      padding: "14px 22px",
    },
  };

  const profileInfoBox = {
    proInfoData: {
      display: "flex",
      flexWrap: "wrap",
      width: "100%",
      justifyContent: "space-between",
      padding: "0",
    },
    leftBox: {
      width: "44%",
    },
    rightBox: {
      width: "52%",
    },
    fullProBox: {
      width: "100%",
      marginBottom: "65px",
      marginTop: "-20px",
    },
    fullProBox2: {
      width: "100%",
      marginBottom: "25px",
      marginTop: "0px",
    },
  };

  const handleOnCLick = (e) => {
    setUserId(null);
  };

  return (
    <>
      <Box
        sx={{
          flexGrow: 1,
          bgcolor: "background.paper",
          display: "flex",
        }}
        className="adminDashboardLeft sidebarTabColHeadResponsive"
      >
        <Tabs
          style={sidebarTabCol.sidebar}
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          className="sidebarTabColResponsive"
        >
          <Tab
            onClick={handleOnCLick}
            label={
              <Box sx={{ display: "flex", gap: 1 }}>
                <img
                  src={user_account_profile_icon}
                  alt="User Icon"
                  style={{ width: 24, height: 24 }}
                />
                User List
              </Box>
            }
            {...a11yProps(0)}
            sx={{
              ...sidebarTabCol.tab_button,
              ...(value === 0 && sidebarTabCol.active_tab),
            }}
          />
          <Tab
            label={
              <Box sx={{ display: "flex", gap: 1 }}>
                <img
                  src={quotation}
                  alt="Project Files Icon"
                  style={{ width: 23, height: 23 }}
                />
                {/* Enquiry / Quotation */}
                Proposals / Projects
              </Box>
            }
            {...a11yProps(1)}
            sx={{
              ...sidebarTabCol.tab_button,
              ...(value === 1 && sidebarTabCol.active_tab),
            }}
          />
          <Tab
            label={
              <Box sx={{ display: "flex", gap: 1 }}>
                <AttachMoneyIcon style={{ width: 23, height: 23 }} />
                Price List
              </Box>
            }
            {...a11yProps(2)}
            sx={{
              ...sidebarTabCol.tab_button,
              ...(value === 2 && sidebarTabCol.active_tab),
            }}
          />
          {/* <Tab
            label={
              <Box sx={{ display: "flex", gap: 1 }}>
                <img
                  src={profileIcon}
                  alt="Profile Icon"
                  style={{ width: 24, height: 24 }}
                />
                Profile
              </Box>
            }
            {...a11yProps(3)}
            sx={{
              ...sidebarTabCol.tab_button,
              ...(value === 3 && sidebarTabCol.active_tab),
            }}
          /> */}

          <Tab
            label={
              <Box sx={{ display: "flex", gap: 1 }}>
                <img
                  src={changePasswordIcon}
                  alt="Change Password Icon"
                  style={{ width: 24, height: 24 }}
                />
                Change Password
              </Box>
            }
            {...a11yProps(3)}
            sx={{
              ...sidebarTabCol.tab_button,
              ...(value === 3 && sidebarTabCol.active_tab),
            }}
          />
          <Tab
            label={
              <Box sx={{ display: "flex", gap: 1 }}>
                <img
                  src={settings}
                  alt="Settings"
                  style={{ width: 24, height: 24 }}
                />
                Settings
              </Box>
            }
            {...a11yProps(4)}
            sx={{
              ...sidebarTabCol.tab_button,
              ...(value === 4 && sidebarTabCol.active_tab),
            }}
          />
          <Tab
            label={
              <Box sx={{ display: "flex", gap: 1 }}>
                <AdminPanelSettingsOutlinedIcon />
                Admin List
              </Box>
            }
            {...a11yProps(5)}
            sx={{
              ...sidebarTabCol.tab_button,
              ...(value === 5 && sidebarTabCol.active_tab),
            }}
          />
          <Tab
            label={
              <Box sx={{ display: "flex", gap: 1 }}>
                <img
                  src={logoutIcon}
                  alt="Logout Icon"
                  style={{ width: 24, height: 24 }}
                />
                Logout
              </Box>
            }
            {...a11yProps(6)}
            sx={{
              ...sidebarTabCol.tab_button,
              ...(value === 6 && sidebarTabCol.active_tab),
            }}
          />
        </Tabs>

        <TabPanel className="dashInfoColumn" value={value} index={0}>
          <Box>
            <h3 className="tabSecTitle">User List</h3>
            <UserList userId={userId} setUserId={setUserId} />
          </Box>
        </TabPanel>
        <TabPanel className="dashInfoColumn" value={value} index={1}>
          <Box>
            <h3 className="tabSecTitle">Enquiry / Quotation</h3>
            <QuoatationTab />
          </Box>
        </TabPanel>
        <TabPanel className="dashInfoColumn" value={value} index={2}>
          <Box style={profileInfoBox.proInfoData}>
            <Box sx={{ width: "100%" }}>
              <h3 className="tabSecTitle">Price List</h3>
              <PriceList />
            </Box>
          </Box>
        </TabPanel>
        {/* <TabPanel className="dashInfoColumn" value={value} index={3}>
          <Box style={profileInfoBox.proInfoData}>
            <Box style={profileInfoBox.fullProBox}>
              <UserProfileInfo />
            </Box>
            <Box style={profileInfoBox.leftBox}>
              <AddressInfo />
            </Box>
            <Box style={profileInfoBox.rightBox}>
              <AddressInfo />
            </Box>
          </Box>
        </TabPanel> */}

        <TabPanel className="dashInfoColumn" value={value} index={3}>
          <Box>
            <h3 className="tabSecTitle">Change Password</h3>
            <ChangePassword />
          </Box>
        </TabPanel>

        <TabPanel className="dashInfoColumn" value={value} index={4}>
          <Box>
            <h3 className="tabSecTitle">Settings</h3>
            <AdminSettings />
          </Box>
        </TabPanel>
        <TabPanel className="dashInfoColumn" value={value} index={5}>
          {/*<h3 className="tabSecTitle">Logout</h3>*/}
          <Box className="adminUser">{<AdminUserList />}</Box>
        </TabPanel>
        <TabPanel className="dashInfoColumn" value={value} index={6}>
          {/*<h3 className="tabSecTitle">Logout</h3>*/}
          <Box className="logoutColRight">
            <LogoutAccount />
          </Box>
        </TabPanel>
      </Box>
      <Box className="accordionBox">
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChange1("panel1")}
          className="accordionBoxInner"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography
              component="span"
              sx={{
                width: "100%",
                flexShrink: 0,
                fontSize: { xs: "16px", sm: "17px", md: "18px" },
                fontWeight: { xs: "600" },
              }}
            >
              User List
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <UserList />
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleChange1("panel2")}
          className="accordionBoxInner"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
          >
            <Typography
              component="span"
              sx={{
                width: "100%",
                flexShrink: 0,
                fontSize: { xs: "16px", sm: "17px", md: "18px" },
                fontWeight: { xs: "600" },
              }}
            >
              Enquiry / Quotation
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <QuoatationTab />
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel6"}
          onChange={handleChange1("panel6")}
          className="accordionBoxInner"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel6bh-content"
            id="panel2bh-header"
          >
            <Typography
              component="span"
              sx={{
                width: "100%",
                flexShrink: 0,
                fontSize: { xs: "16px", sm: "17px", md: "18px" },
                fontWeight: { xs: "600" },
              }}
            >
              Price List
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <PriceList />
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel3"}
          onChange={handleChange1("panel3")}
          className="accordionBoxInner"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
          >
            <Typography
              component="span"
              sx={{
                width: "100%",
                flexShrink: 0,
                fontSize: { xs: "16px", sm: "17px", md: "18px" },
                fontWeight: { xs: "600" },
              }}
            >
              Profile
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <Box style={profileInfoBox.proInfoData}>
                <Box style={profileInfoBox.fullProBox}>
                  <UserProfileInfo />
                </Box>
                <Box style={profileInfoBox.fullProBox2}>
                  {/* <PersonalInfo />                   */}
                </Box>
                <Box style={profileInfoBox.fullProBox2}>
                  <AddressInfo />
                </Box>
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel4"}
          onChange={handleChange1("panel4")}
          className="accordionBoxInner"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
          >
            <Typography
              component="span"
              sx={{
                width: "100%",
                flexShrink: 0,
                fontSize: { xs: "16px", sm: "17px", md: "18px" },
                fontWeight: { xs: "600" },
              }}
            >
              Change Password
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <ChangePassword />
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel5"}
          onChange={handleChange1("panel5")}
          className="accordionBoxInner"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5bh-content"
            id="panel4bh-header"
          >
            <Typography
              component="span"
              sx={{
                width: "100%",
                flexShrink: 0,
                fontSize: { xs: "16px", sm: "17px", md: "18px" },
                fontWeight: { xs: "600" },
              }}
            >
              Logout
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box>
              <LogoutAccount />
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  );
}

// Dashboard Page Component
export default function AdminDashBoardPage() {
  const boardStyle = {
    logRegBox: {
      display: "flex",
    },
  };

  return (
    <Container maxWidth="xl">
      <Box className="dashboard_frame">
        <Box className="backBtnFrame">
          <Button className="dashboardTitle" variant="contained">
            <img
              src={logoVector}
              alt="Flyover"
              style={{ height: 45, marginRight: 25 }}
            />
            Admin Dashboard
          </Button>
        </Box>

        <Box style={boardStyle.logRegBox}>
          <VerticalTabs />
        </Box>
      </Box>
    </Container>
  );
}
